import modalStyle from "../../modal.module.scss";

import React, { useState, useEffect } from 'react';
import { Box, Select, MenuItem, TextField } from "@mui/material";

import { isValidIpV4, isSameSubnet } from "utils/network-validation";
import { getDefaultSelectProp, getDefaultTextFieldProp } from "../../../theme";
import { defaultIpModeState } from "../../../const";

const IpSettings = (props) => {
  const {
    ipModeOptions,
    setIpModeOptions,
    ipAddress,
    setIpAddress,
    subnetMask,
    setSubnetMask,
    gateway,
    setGateway,
    dns1,
    setDns1,
    dns2,
    setDns2,
    setIpSettingsStatus,
    isAllNotSupportDNSDevice
  } = props;

  // State
  const [isError, setIsError] = useState({
    ipAddress: false,
    subnetMask: false,
    gateway: false,
    dns1: false,
    dns2: false,
  });

  // Method
  const changeIpMode = (value) => {
    const updatedIpModeOptions = ipModeOptions.map((option) => ({
      ...option,
      selected: option.value === value,
    }));

    setIpModeOptions(updatedIpModeOptions);

    if (value === defaultIpModeState.static.value) {
      setIpAddress('');
      setSubnetMask('');
      setGateway('');
      setDns1('');
      setDns2('');
    }
  }

  // Side effect
  useEffect(() => {
    const updatedIpModeOptions = Object.values(defaultIpModeState).map((option) => ({
      ...option,
      selected: false,
    }));

    updatedIpModeOptions[0].selected = true;
    setIpModeOptions(updatedIpModeOptions);
  }, []);

  useEffect(() => {
    let result = false;

    if (ipModeOptions.find((option) => option.selected)?.value === defaultIpModeState.static.value) {
      if (isAllNotSupportDNSDevice()) {
        if (ipAddress === '' || ipAddress === '0.0.0.0' || subnetMask === '' || gateway === '') {
          result = true;
        }
      } else {
        if (ipAddress === '' || ipAddress === '0.0.0.0' || subnetMask === '' || gateway === '' || dns1 === '' || dns1 === '0.0.0.0' || dns2 === '' || dns2 === '0.0.0.0') {
          result = true;
        }
      }

      if (isError.ipAddress || isError.subnetMask || isError.gateway || isError.dns1 || isError.dns2) {
        result = true;
      }
    }

    setIpSettingsStatus(!result);
  }, [dns1, dns2, gateway, ipAddress, ipModeOptions, isError, setIpSettingsStatus, subnetMask]);

  // 監聽子網段並即時同步到 isError.gateway
  useEffect(() => {
    if (ipModeOptions.find((option) => option.selected)?.value !== defaultIpModeState.static.value) {
      return;
    }

    const ipValid = isValidIpV4(ipAddress) && ipAddress !== '0.0.0.0';
    const subnetValid = isValidIpV4(subnetMask);
    const gatewayValid = isValidIpV4(gateway);

    if (ipValid && subnetValid && gatewayValid) {
      const isSubnetMatch = isSameSubnet(ipAddress, gateway, subnetMask);
      setIsError(prev => ({
        ...prev,
        gateway: !isSubnetMatch
      }));
    } else {
      setIsError(prev => ({
        ...prev,
        gateway: gateway !== '' ? !isValidIpV4(gateway) : false
      }));
    }
  }, [ipAddress, subnetMask, gateway, ipModeOptions]);

  return (
    <>
      {
        ipModeOptions.find((option) => option.selected)?.value === defaultIpModeState.dhcp.value && (
          <>
            {/* IP mode, Default gateway */}
            <Box display="flex" flexDirection="row" justifyContent="space-between" gap={8} style={{ marginBottom: '8px' }}>
              <Box display="flex" flexDirection="row" justifyContent="center" style={{ flex: 1 }}>
                <div className={modalStyle['field']} style={{ flex: 2, paddingLeft: '8px', paddingTop: '10px' }}>
                  IP Mode
                </div>
                <div className={modalStyle['item']} style={{ flex: 3 }}>
                  <Select
                    style={{ ...getDefaultSelectProp().style, width: "100%" }}
                    value={ipModeOptions.find((option) => option.selected)?.value || ""}
                    onChange={(e) => changeIpMode(e.target.value)}
                    sx={{ ...getDefaultSelectProp().sx }}
                    MenuProps={{ ...getDefaultSelectProp().menuProps }}
                  >
                    {
                      ipModeOptions.map((item, index) => (
                        <MenuItem
                          value={item.value} key={index}
                        >
                          {item.label}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </div>
              </Box>
              <Box display="flex" flexDirection="row" justifyContent="center" style={{ flex: 1 }}>
              </Box>
            </Box >
          </>
        )
      }
      {
        ipModeOptions.find((option) => option.selected)?.value === defaultIpModeState.static.value && (
          <>
            {/* IP mode, Default gateway */}
            <Box display="flex" flexDirection="row" justifyContent="space-between" gap={8} style={{ marginBottom: '8px' }}>
              <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" style={{ flex: 1 }}>
                <div style={{ flex: 2, paddingLeft: '8px' }}>
                  IP Mode
                </div>
                <div className={modalStyle['item']} style={{ flex: 3 }}>
                  <Select
                    style={{ ...getDefaultSelectProp().style, width: "98%" }}
                    value={ipModeOptions.find((option) => option.selected)?.value || ""}
                    onChange={(e) => changeIpMode(e.target.value)}
                    sx={{ ...getDefaultSelectProp().sx }}
                    MenuProps={{ ...getDefaultSelectProp().menuProps }}
                  >
                    {
                      ipModeOptions.map((item, index) => (
                        <MenuItem value={item.value} key={index}>{item.label}</MenuItem>
                      ))
                    }
                  </Select>
                </div>
              </Box>
              <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" style={{ flex: 1 }}>
                <Box style={{ flex: 2, paddingLeft: '8px' }}>
                  Default Gateway
                </Box>
                <Box className={modalStyle['item']} style={{ flex: 3 }}>
                  <TextField
                    fullWidth
                    placeholder=""
                    type="text"
                    value={gateway}
                    autoComplete="new-password"
                    onChange={(e) => {
                      setGateway(e.target.value);
                      setIsError({ ...isError, gateway: !isValidIpV4(e.target.value) });
                    }}
                    sx={{ ...getDefaultTextFieldProp().sx }}
                    error={isError.gateway}
                  />
                  {
                    isError.gateway && (
                      <Box className={modalStyle['error']}>
                        Invalid format
                      </Box>
                    )
                  }
                </Box>
              </Box>
            </Box >
            {/* Start IP address, Primary DNS server */}
            <Box display="flex" flexDirection="row" justifyContent="space-between" gap={8} style={{ marginBottom: '8px' }}>
              <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" style={{ flex: 1 }}>
                <div style={{ flex: 2, paddingLeft: '8px' }}>
                  Start IP Address
                </div>
                <div className={modalStyle['item']} style={{ flex: 3 }}>
                  <TextField
                    fullWidth
                    placeholder=""
                    type="text"
                    value={ipAddress}
                    autoComplete="new-password"
                    onChange={(e) => {
                      setIpAddress(e.target.value);
                      setIsError({ ...isError, ipAddress: !isValidIpV4(e.target.value) || e.target.value === '0.0.0.0' });
                    }}
                    sx={{ ...getDefaultTextFieldProp().sx }}
                    error={isError.ipAddress}
                  />
                  {
                    isError.ipAddress && (
                      <Box className={modalStyle['error']}>
                        Invalid format
                      </Box>
                    )
                  }
                </div>
              </Box>
              {
                !isAllNotSupportDNSDevice() ? (
                  <>
                    <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" style={{ flex: 1 }}>
                      <div style={{ flex: 2, paddingLeft: '8px' }}>
                        Primary DNS Server
                      </div>
                      <div className={modalStyle['item']} style={{ flex: 3 }}>
                        <TextField
                          fullWidth
                          placeholder=""
                          type="text"
                          value={dns1}
                          autoComplete="new-password"
                          onChange={(e) => {
                            setDns1(e.target.value);
                            setIsError({ ...isError, dns1: !isValidIpV4(e.target.value) || e.target.value === '0.0.0.0' });
                          }}
                          sx={{ ...getDefaultTextFieldProp().sx }}
                        />
                        {
                          isError.dns1 && (
                            <Box className={modalStyle['error']}>
                              Invalid format
                            </Box>
                          )
                        }
                      </div>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" style={{ flex: 1 }}>

                    </Box>
                  </>
                )
              }
            </Box >
            {/* Subnet mask, Secondary DNS server */}
            <Box display="flex" flexDirection="row" justifyContent="space-between" gap={8} style={{ marginBottom: '8px' }}>
              <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" style={{ flex: 1 }}>
                <div style={{ flex: 2, paddingLeft: '8px' }}>
                  Subnet Mask
                </div>
                <div className={modalStyle['item']} style={{ flex: 3 }}>
                  <TextField
                    fullWidth
                    placeholder=""
                    type="text"
                    value={subnetMask}
                    autoComplete="new-password"
                    onChange={(e) => {
                      setSubnetMask(e.target.value);
                      setIsError({ ...isError, subnetMask: !isValidIpV4(e.target.value) });
                    }}
                    sx={{ ...getDefaultTextFieldProp().sx }}
                    error={isError.subnetMask}
                  />
                  {
                    isError.subnetMask && (
                      <Box className={modalStyle['error']}>
                        Invalid format
                      </Box>
                    )
                  }
                </div>
              </Box>
              {
                !isAllNotSupportDNSDevice() ? (
                  <>
                    <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" style={{ flex: 1 }}>
                      <div style={{ flex: 2, paddingLeft: '8px' }}>
                        Secondary DNS Server
                      </div>
                      <div className={modalStyle['item']} style={{ flex: 3 }}>
                        <TextField
                          fullWidth
                          placeholder=""
                          type="text"
                          value={dns2}
                          autoComplete="new-password"
                          onChange={(e) => {
                            setDns2(e.target.value);
                            setIsError({ ...isError, dns2: !isValidIpV4(e.target.value) || e.target.value === '0.0.0.0' });
                          }}
                          sx={{ ...getDefaultTextFieldProp().sx }}
                        />
                        {
                          isError.dns2 && (
                            <Box className={modalStyle['error']}>
                              Invalid format
                            </Box>
                          )
                        }
                      </div>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" style={{ flex: 1 }}>

                    </Box>
                  </>
                )
              }
            </Box >
          </>
        )
      }
    </>
  );
}

export default IpSettings;